import { render } from "./Favourites.vue?vue&type=template&id=cdfdebc8&scoped=true&bindings={\"makeBooking\":\"data\",\"sendBooking\":\"data\",\"showShare\":\"data\",\"favourites\":\"options\",\"showFavourite\":\"options\",\"clearFavourites\":\"options\",\"handleBooking\":\"options\",\"showSentDialog\":\"options\",\"handleSendBooking\":\"options\",\"handleShare\":\"options\"}"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"

import "./Favourites.vue?vue&type=style&index=0&id=cdfdebc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cdfdebc8"

export default script